import React from "react";
import { useAuthStore } from "../store/AuthStore";

interface AuthModalProps {
  onClose: () => void;
}

export default function AuthModal({ onClose }: AuthModalProps) {
  const { loginWithGoogle, isAuthLoading } = useAuthStore();

  const handleGoogle = async () => {
    try {
      await loginWithGoogle();
      onClose(); // Close the modal since the user is now authenticated
    } catch (err) {
      console.error("Login failed", err);
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="bg-neutral-900 border border-neutral-800 rounded-3xl shadow-2xl w-full max-w-sm p-8 flex flex-col items-center gap-5"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Logo */}
        <img
          src="/logo.png"
          alt="Birdetector"
          className="w-16 h-16 rounded-full bg-white object-cover shadow-lg"
        />

        <div className="text-center">
          <h2 className="text-xl font-bold text-white">Welcome to Birdetector</h2>
          <p className="text-neutral-400 text-sm mt-1">
            Sign in to save your favorite scan locations and access them from any device.
          </p>
        </div>

        {/* Google Button */}
        <button
          onClick={handleGoogle}
          disabled={isAuthLoading}
          className="w-full flex items-center justify-center gap-3 bg-white hover:bg-neutral-100 text-neutral-900 font-semibold py-3 px-5 rounded-xl transition shadow-md"
        >
          {/* Google Icon SVG */}
          <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          Continue with Google
        </button>

        {/* Divider */}
        <div className="w-full flex items-center gap-3 text-neutral-700 text-xs">
          <div className="flex-1 h-px bg-neutral-800" />
          more providers coming soon
          <div className="flex-1 h-px bg-neutral-800" />
        </div>

        {/* Cancel */}
        <button
          onClick={onClose}
          className="text-neutral-500 hover:text-neutral-300 text-sm transition"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
